export enum ShapePackagingStrategy {
  /**
   * Needs max w x h x l constraints.
   */
  BOX = 'BOX',

  /**
   * Needs max w x h constraints.
   */
  RECTANGLE = 'RECTANGLE',

  /**
   * Max volume as a scalar.
   */
  VOLUME = 'VOLUME',

  /**
   * Max area as a scalar.
   */
  AREA = 'AREA',
}
